import React, { Fragment } from 'react';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import Typography from '@mui/material/Typography';

import CalendarRangeFilter from '@components/Filters/CalendarRangeFilter';
import CheckBoxFilterGroup from '@components/Filters/CheckboxFilterGroup';
import RangeSlider from '@components/Filters/RangeSlider';

const DynamicFilters = ({
  config = {},
  onChange = () => {},
  params = {},
  options = [],
  isFilterLoading = false
}) => {
  const isFilterActive = Object.values(params[config?.name] || {})?.some(Boolean);

  const handleFilter = () => {
    switch (config.filterType) {
      case 'calendarRange':
        return (
          <CalendarRangeFilter
            key={config?.name}
            title={config.title}
            disabledFrom={config?.from?.disabled}
            disabledTo={config?.to?.disabled}
            valueFrom={get(params, config.from.name)}
            valueTo={get(params, config.to.name)}
            handleDateChange={onChange}
            name={config.name}
            disabled={config?.disabled}
          />
        );
      case 'checkboxGroup':
        return (
          <CheckBoxFilterGroup
            key={config?.name}
            title={config.title}
            responseFilterKey={config?.responseFilterKey}
            values={params[config.name]}
            showSearch={config.showSearch}
            filterName={config?.options}
            handleOnChange={onChange}
            groupName={config.name}
            disabled={config?.disabled}
            options={options}
            opened={isFilterActive}
            isFilterLoading={isFilterLoading}
          />
        );

      case 'slider': {
        return (
          <RangeSlider
            key={config?.name}
            groupName={config.name}
            title={config.title}
            ariaLabel={config.ariaLabel}
            value={params[config.name]}
            rangeUnit={config.rangeUnit}
            handleChange={onChange}
            options={options}
            disabled={config?.disabled}
          />
        );
      }

      default:
        return <Typography>{Localize.get('CustomerLoyaltyEvents.noFilter')}</Typography>;
    }
  };
  return !config?.hideElement ? <Fragment>{handleFilter(config.filterType)}</Fragment> : null;
};

export default DynamicFilters;
